export enum EnaioChildObjectSelectionType {
    none = 0,
    userDefined = 1,
    registers = 2,
    documents = 3,
    all = 4
}
export namespace EnaioChildObjectSelectionType{
    export function getName(value: EnaioChildObjectSelectionType): string {
        switch (value) {
            case EnaioChildObjectSelectionType.none:
                return "none";
            case EnaioChildObjectSelectionType.userDefined:
                return "userDefined";
            case EnaioChildObjectSelectionType.registers:
                return "registers";
            case EnaioChildObjectSelectionType.documents:
                return "documents";
            case EnaioChildObjectSelectionType.all:
                return "all";
        }
    }
}
